import { Component } from '@angular/core';
import * as project from '../../../../../../package.json';
@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent {

  version = project.version;

  constructor() { }

}
